
import GridCellExpand from "./GridCellExpand"
import { DataGridPro, GridToolbarContainer, GridToolbarExport, useGridApiContext } from "@mui/x-data-grid-pro";
import React, { useCallback, useContext, useMemo, useState } from "react";
import { Box, Button, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Paper, Popover } from "@mui/material";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ArticleIcon from '@mui/icons-material/Article';
import SearchIcon from '@mui/icons-material/Search';
import dayjs from "dayjs";
import { lightBlue } from '@mui/material/colors';
import ShipmentDocDialog from "./ShipmentDocDialog";
import CheckboxFormControl from "components/CheckboxFormControl";
import { useEffect } from "react";
import { noYearColNms } from "./noYearColNms";
import { getPOIPlace } from "utils/getPOIPlace";
import { onKeyDownCopy } from "utils/dataGridOnCellKeyDownCopy";
import ShipmentDialog from "pages/Menu1/ShipmentManagement/ShipmentDialog";
import { FilePresentRounded, SaveRounded } from "resource/muiImport";
import CustomerDialog from "pages/Menu2/CustomerManagement/CustomerDialog";
import JobDialog from "pages/Menu2/JobManagement/JobDialog";
import DriverDialog from "pages/Menu2/DriverManagement/DriverDialog";
import TruckDialog from "pages/Menu2/TruckManagement/TruckDialog";
import POIDialog from "pages/Menu2/POIManagement/POIDialog";
import { UserContext } from "contexts/UserContext";
import { accountApiNm, defaultUserPref } from "constants/accountConstant";
import { GlobalStateContext } from "contexts/GlobalStateContext";
import { alertSuccess } from "components/Alert";
import { loadMSData } from "utils";
import SubcontractDialog from "pages/Menu2/SubcontractManagement/SubcontractDialog";

const modifyColumn = (innerColumns, setInnerColumns, setIsShowYear, isChecked) => {
  for (const col of innerColumns) {
    let width = 100;
    let format = "DD/MM HH:mm";
    if (isChecked) {
      width = 120;
      format = "DD/MM/YY HH:mm";
    }
    if (noYearColNms.includes(col.field)) {
      col.width = width;
      col.valueFormatter = (params) => params.value ? dayjs(params.value).format(format) : "-";

    }

    setInnerColumns([...innerColumns])
    setIsShowYear(isChecked);
  }
}

const ShowYear = ({ innerColumns, setInnerColumns, isShowYear, setIsShowYear }) => {

  // const apiRef = useGridApiContext();

  const handleCheckChange = useCallback((e) => {
    // const columnsx = apiRef.current.d


    modifyColumn(innerColumns, setInnerColumns, setIsShowYear, e.target.checked);



    // apiRef.current.setState(o=>{

    //   // return o
    //   return {
    //     ...o,
    //     columns: {
    //       all: columnsx.map(col=>col.field),
    //       columnVisibilityModel: columnsx.reduce((prev, cur)=>({...prev, [cur.field]: !cur.hide}), {}),
    //       lookup: columnsx.reduce((prev, cur)=>({
    //         ...prev,
    //         [cur.field]:{...cur}
    //       }), {})
    //     }
    //   }
    // })
  }, [innerColumns, setInnerColumns, setIsShowYear])
  return (
    <Button>
      <CheckboxFormControl sx={{ ml: 1 }} label="แสดงปี" checked={isShowYear} onChange={handleCheckChange} />
    </Button>
  )
}

const SaveColumn = () => {

  const apiRef = useGridApiContext();

  const { user, setUser } = useContext(UserContext)
  const { ax, setMSData } = useContext(GlobalStateContext)

  const handleSaveColumns = useCallback(() => {



    const userPref = JSON.parse(user.UsrPref)

    const dailyTableColWidth = user.dailyJobTableCols || defaultUserPref.DailyTableColWidth
    // let dailyTableColWidth = userPref.DailyTableColWidth ? userPref.DailyTableColWidth : defaultUserPref.DailyTableColWidth


    const allColumns = apiRef.current.getAllColumns()
    const pinnedColumns = apiRef.current.getPinnedColumns()

    let order = 0;
    for (const col of allColumns) {
      const found = dailyTableColWidth.find(c => c.field === col.field)
      order++
      if (found) {
        found.width = col.computedWidth
        found.order = order
        found.pinned = ""
      }
      // else {
      //   dailyTableColWidth.push({
      //     field: col.field,
      //     width: col.computedWidth,
      //     order: order,
      //     visible: true,
      //     colClr: null
      //   })
      // }
    }

    for (const col of pinnedColumns.left) {
      const found = dailyTableColWidth.find(c => c.field === col)
      if (found) {
        found.pinned = "LEFT"
      }
    }

    for (const col of pinnedColumns.right) {
      const found = dailyTableColWidth.find(c => c.field === col)
      if (found) {
        found.pinned = "RIGHT"
      }
    }

    const postDataStr = JSON.stringify({
      ...(userPref || defaultUserPref),
      DailyTableColWidth: dailyTableColWidth,
    })

    ax.post(accountApiNm.updateUserPref, { AccId: user.AccId, UsrPref: postDataStr }).then(value => {
      if (value.data) {
        loadMSData(ax, setMSData, setUser)
        alertSuccess("บันทึกคอลัมน์เรียบร้อยแล้ว")

        // setDialogOpen(false)
      }
    })
    // const columnState = apiRef.current.getState().columns;
    // const columnOrder = columnState.all; // Array of column field names in order
    // const columnWidths = columnState.lookup; // Object with column field names as keys and their properties (e.g., width)

    // const columnData = columnOrder.map((field) => ({
    //   field,
    //   width: columnWidths[field]?.width,
    // }));



    // You can save this data to a database, localStorage, or wherever needed
  }, [user, ax, apiRef, setUser, setMSData])

  return <Button onClick={handleSaveColumns}><SaveRounded sx={{ mr: 1 }} /> บันทึกคอลัมน์</Button>;
}
const CustomToolbar = (props) => () => {


  return (
    <GridToolbarContainer>
      <GridToolbarExport
        csvOptions={{
          utf8WithBom: true,
          // getRowsToExport: (params)=>{

          //   return params.apiRef.current.getAllRowIds()
          // }
        }} />
      <ShowYear {...props} />
      {props.saveColNm ? <SaveColumn saveColNm={props.saveColNm} /> : null}
      {
        props.extraToolbar || []
      }
    </GridToolbarContainer>
  );
}
const ContextListItem = ({ label, icon, onClick }) => (
  <ListItem disablePadding>
    <ListItemButton onClick={onClick}>
      <ListItemIcon sx={{ minWidth: 0, pr: 1 }}>{icon}</ListItemIcon>
      <ListItemText>{label}</ListItemText>
    </ListItemButton>
  </ListItem>
)

let mousePositionX = 0
let mousePositionY = 0
let value = null
let field = null
let row = null
let refId = null
const fieldNm = {
  JobNo: "ใบแจ้งลาก",
  Bkg: "ใบแจ้งลาก",
  CusSNm: "ลูกค้า",
  CusNm: "ลูกค้า",
  JobSNm: "งาน",
  DrvNNm: "พนักงานขับรถ",
  TukCd: "รถ",
  TakePOIId: "สถานที่",
  RtnPOIId: "สถานที่",
  LocPOIId: "สถานที่",
  POIId: "สถานที่",
  TakePlc: "สถานที่",
  RtnPlc: "สถานที่",
  Loc: "สถานที่",
  POISNm: "สถานที่",
  ScNm: "รถร่วม",
  ScSNm: "รถร่วม"
}
const DataGridCellExpand = (props) => {


  const { user } = useContext(UserContext)

  const { columns, rows, extraContext, refreshData, saveColNm, isFixNo = true, isShowLastNo = true } = props

  const [popOverOpen, setPopOverOpen] = useState(false)
  const [queryUrl, setQueryUrl] = useState(null)
  const [shpmId, setShpmId] = useState(0)
  const [dialogOpen, setDialogOpen] = useState(false)
  const [dialogShipmentOpen, setDialoShipmentOpen] = useState(false)
  const [dialogTukOpen, setDialogTukOpen] = useState(false)
  const [dialogDrvOpen, setDialogDrvOpen] = useState(false)
  const [dialogCusOpen, setDialogCusOpen] = useState(false)
  const [dialogJobOpen, setDialogJobOpen] = useState(false)
  const [dialogPOIOpen, setDialogPOIOpen] = useState(false)
  const [dialogScOpen, setDialogScOpen] = useState(false)
  const [innerColumns, setInnerColumns] = useState(columns)
  const [isShowYear, setIsShowYear] = useState(false)

  const showSearch = Boolean(queryUrl)
  const showViewDetail = Boolean(refId)

  const userPrefTableDensity = useMemo(() => {
    if (!user) return defaultUserPref.GeneralData.TableDensity
    const userPref = JSON.parse(user.UsrPref)
    return userPref?.GeneralData?.TableDensity || defaultUserPref.GeneralData.TableDensity
  }, [user])


  const handlePopoverOpen = (event) => {
    event.preventDefault();
    mousePositionX = event.pageX
    mousePositionY = event.pageY
    setPopOverOpen(true);





    field = event.currentTarget.dataset.field;
    const id = event.currentTarget.parentElement.dataset.id;
    row = rows.find((r) => r.id.toString() === id);

    if (["AptTm", "FinDte", "LevTm", "ArvTm", "TakeDteSt", "TakeDteEn", "RtnDteSt", "RtnDteEn"
      , "InvDte", "RcptDte", "BNDte", "RVDte", "RecvDocDte", "MemTm", "ShorDte"].includes(field) && value) {
      value = dayjs(value).format("YYYY-MM-DD HH:mm")
    } else if (field === "TakePlc") {
      value = getPOIPlace(row, "TAKE")
    } else if (field === "Loc") {
      value = getPOIPlace(row, "LOC")
    } else if (field === "RtnPlc") {
      value = getPOIPlace(row, "RTN")
    } else {
      value = row[field]
    }

    if (["ContNo", "JobNo", "Bkg", "JobOrdId"].includes(field) && value) {

      const pathName = window.location.pathname
      let path = `${field}/${value}`
      if (field === "JobNo" && row.ShpmId) {
        path = `ShpmId/${row.ShpmId}`
      } else if (field === "Bkg") {
        path = `BkgExact/${value}`
      }
      if (pathName.startsWith("/emily"))
        setQueryUrl(`/emily/DailyJob/${path}`)
      else if (pathName.startsWith("/client")) {
        setQueryUrl(`/client/DataQuery/${path}`)
      } else {
        setQueryUrl(null)
      }
    } else {
      setQueryUrl(null)
    }
    if (["JobNo"].includes(field) && value) {
      setShpmId(row.ShpmId ? row.ShpmId : null)
    } else {
      setShpmId(null)
    }
    if (["JobNo", "Bkg", "CusSNm", "CusNm", "JobSNm", "DrvNNm", "TukCd", "TakePOIId", "RtnPOIId"
      , "LocPOIId", "POIId", "TakePlc", "RtnPlc", "Loc", "POISNm", "ScNm", "ScSNm"].includes(field)) {
      if (["JobNo", "Bkg"].includes(field)) {
        refId = row.ShpmId
      } else if (["TakePlc", "RtnPlc", "Loc"].includes(field)) {
        refId = row[field.replace("Plc", "") + "POIId"]
      } else if (field === "DrvNNm") {
        refId = row.DrvId
      } else if (field === "TukCd") {
        refId = row.TukId
      } else if (field === "CusSNm" || field === "CusNm") {
        refId = row.CusId
      } else if (field === "JobSNm") {
        refId = row.JobId
      } else if (["POIId", "TakePOIId", "LocPOIId", "RtnPOIId"].includes(field)) {
        refId = row[field]
      } else if (field === "POISNm") {
        refId = row.POIId
      } else if (field === "ScSNm" || field === "ScNm") {
        refId = row.ScId
      } else {
        refId = row[field]
      }
    } else {
      refId = null
    }
  };

  const handleCopy = useCallback(() => {
    navigator.clipboard.writeText(value).then(setPopOverOpen(false))
  }, [])

  const handleSearch = useCallback(() => {
    var win = window.open(window.location.origin + queryUrl, '_blank');
    win.focus();
    setPopOverOpen(false)
  }, [queryUrl])

  const handleOpenShipmentDoc = useCallback(() => {
    setPopOverOpen(false)
    setDialogOpen(true)
  }, [])

  const handleOnCellKeyDown = useCallback((params, event) => {
    if (onKeyDownCopy(event, params.value)) return
  }, [])

  const handleOpenDetailDialog = useCallback(() => {
    if (["JobNo", "Bkg"].includes(field)) {
      setDialoShipmentOpen(true)
    } else if (["TakePlc", "RtnPlc", "Loc", "TakePOIId", "LocPOIId", "RtnPOIId", "POISNm"].includes(field)) {
      setDialogPOIOpen(true)
    } else if (field === "DrvNNm") {
      setDialogDrvOpen(true)
    } else if (field === "TukCd") {
      setDialogTukOpen(true)
    } else if (field === "CusSNm" || field === "CusNm") {
      setDialogCusOpen(true)
    } else if (field === "JobSNm") {
      setDialogJobOpen(true)
    } else if (field === "ScSNm" || field === "ScNm") {
      setDialogScOpen(true)
    }
    setPopOverOpen(false)
  }, [])

  const onFinish = useCallback(() => {
    if (refreshData) refreshData()
  }, [refreshData])

  const shipmentDialogStateMemo = useMemo(() => ({ dialogOpen: dialogShipmentOpen, selectedId: refId, }), [dialogShipmentOpen])
  const shipmentDialogFnMemo = useMemo(() => ({ setDialogOpen: setDialoShipmentOpen, onFinish: onFinish }), [onFinish])

  useEffect(() => {
    const newColumns = columns.map(col => {
      const newCol = { ...col };

      if (!newCol.renderCell && !newCol.getActions) {
        newCol.renderCell = (params) => (
          <GridCellExpand
            value={(newCol.valueFormatter ? newCol.valueFormatter(params) : params.value) || ''}
            width={params.colDef.computedWidth}
            align={newCol.align} />
        )
      }
      newCol.headerClassName = (newCol.headerClassName || "") + " header-style"

      // Auto-apply sequential numbering to "No" column
      if (newCol.field === "No" && !newCol.valueGetter && isFixNo) {
        newCol.valueGetter = (params) => params.id === 0 ? 
        isShowLastNo ? rows.length -1: "" : params.api.getRowIndexRelativeToVisibleRows(params.id) + 1
        newCol.sortable = false
      }

      return newCol;
    });

    setInnerColumns(newColumns)
  }, [columns, isFixNo, isShowLastNo, rows.length])

  /**
   * Want to automatic add year b4 export csv but 
   * has a problem with need to wait data rerender 
   * after set state can setTimeout b4 fn() but i 
   * think that is not a good idea
   */
  // useEffect(()=>{

  //   const fn = apiRef.current.exportDataAsCsv
  //   apiRef.current.exportDataAsCsv = () =>{


  //     modifyColumn(innerColumns, setInnerColumns, setIsShowYear, true);
  //     fn({ utf8WithBom: true})
  //   }
  // }, [apiRef, innerColumns])
  return (
    <Box height="100%" sx={{
      '& .header-style': {
        bgcolor: (theme) => lightBlue[100]
      },
      '& .MuiDataGrid-columnSeparator	': {
        color: 'white!important'
      }
    }}>
      <DataGridPro
        componentsProps={{
          cell: {
            onContextMenu: handlePopoverOpen,
          },
          // row: {
          //   onKeyUp: handleOnKeyUp
          // }
        }}
        components={{
          NoRowsOverlay: () => (<Box mt={4} textAlign="center">ไม่พบข้อมูล</Box>),
          Toolbar: !props.hideToolbar && CustomToolbar({
            saveColNm, innerColumns
            , setInnerColumns, isShowYear, setIsShowYear, extraToolbar: props.extraToolbar
          })
        }}
        onCellKeyDown={handleOnCellKeyDown}
        disableSelectionOnClick

        density={userPrefTableDensity}
        {...props}
        columns={innerColumns} />
      <Popover
        open={popOverOpen}
        onClose={() => setPopOverOpen(false)}
        anchorReference="anchorPosition"
        anchorPosition={{ top: mousePositionY, left: mousePositionX }}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        disableRestoreFocus
      >
        <Paper>
          <List disablePadding>
            <ContextListItem label="คัดลอก" icon={<ContentCopyIcon />} onClick={handleCopy} />
            {showSearch &&
              <ContextListItem label="ค้นหา" icon={<SearchIcon />} onClick={handleSearch} />
            }
            {shpmId &&
              <ContextListItem label="เอกสารใบแจ้งลาก" icon={<FilePresentRounded />} onClick={handleOpenShipmentDoc} />
            }
            {
              showViewDetail && user && user.AccTypId === 1 &&
              <ContextListItem label={`ดูรายละเอียด ${fieldNm[field]}`} icon={<ArticleIcon />} onClick={handleOpenDetailDialog} />
            }
            {extraContext && extraContext.map(item => (
              <ContextListItem key={item.label} label={item.label} icon={item.icon}
                onClick={() => {
                  item.onClick(row, field, value)
                  setPopOverOpen(false)
                }} />
            ))
            }
          </List>
        </Paper>
      </Popover>
      <ShipmentDocDialog dialogOpen={dialogOpen} setDialogOpen={setDialogOpen} shpmId={shpmId} headerText={value} />
      {user && user.AccTypId === 1 &&
        <ShipmentDialog state={shipmentDialogStateMemo}
          fn={shipmentDialogFnMemo} />
      }
      {user && user.AccTypId === 1 &&
        <CustomerDialog state={{ dialogOpen: dialogCusOpen, selectedCusId: refId }}
          fn={{ setDialogOpen: setDialogCusOpen, onFinish: onFinish }} />
      }
      {user && user.AccTypId === 1 &&
        <JobDialog state={{ dialogOpen: dialogJobOpen, selectedId: refId }}
          fn={{ setDialogOpen: setDialogJobOpen, onFinish: onFinish }} />
      }
      {user && user.AccTypId === 1 &&
        <DriverDialog state={{ dialogOpen: dialogDrvOpen, selectedId: refId }}
          fn={{ setDialogOpen: setDialogDrvOpen, onFinish: onFinish }} />
      }
      {user && user.AccTypId === 1 &&
        <TruckDialog state={{ dialogOpen: dialogTukOpen, selectedId: refId }}
          fn={{ setDialogOpen: setDialogTukOpen, onFinish: onFinish, }} />
      }
      {user && user.AccTypId === 1 &&
        <POIDialog selectedId={refId} dialogOpen={dialogPOIOpen} setDialogOpen={setDialogPOIOpen}
          onFinish={onFinish} lastFilter={null} />
      }
      {user && user.AccTypId === 1 &&
        <SubcontractDialog selectedId={refId} dialogOpen={dialogScOpen} setDialogOpen={setDialogScOpen}
          onFinish={onFinish} lastFilter={null} />
      }
    </Box>
  )
}

export default DataGridCellExpand